// KOBEミナトマチカレー — 店舗情報（単一の情報源）
// 「要確認」となっている項目は、まだ確定情報が届いていない項目です。
// 情報が確定したら、ここを更新するだけで全ページに反映されます。

export const STORE = {
  brandName: "KOBEミナトマチカレー",
  storeName: "神戸ミナトマチカレー",
  storeNameEn: "Kobe Minatomachi Curry",
  storeFullName: "KOBEミナトマチカレー 神戸ハーバーランドumie店",

  // ブランドタグライン（プレスリリース記載の正式タグライン）
  tagline: "肉の旨さで食べる、ごちそう港町カレー",
  // キャッチコピー（画像ステッカー等で使用）
  catchcopy: "まるごとかける、港町のごちそう",
  // ブランドコピー（ヒーロー／フッターで使用）
  brandCopy: "神戸の海辺に、新しいカレーの旗が立つ。",

  // 営業ステータス（オープン告知ではなく「営業中」表現で統一）
  statusLabel: "営業中",
  statusLabelLong: "神戸ハーバーランドumieで営業中",

  // 開店日（実績値。現在サイト上では表示していない）
  openDateISO: "2026-08-25",
  openDateLabel: "2026年8月25日（火）",

  // 施設名はプレスリリース記載の正式表記に統一
  // （「イオンスタイルumie」は umie NORTH MALL 内の一テナント名であり、
  // 　施設全体の名称ではないため使用しない）
  facilityName: "神戸ハーバーランド umie",
  facilityNameShort: "umie NORTH MALL",
  floorLabel: "NORTH MALL 地下1階 フードコート",
  postalCode: "〒650-0044",
  address: "兵庫県神戸市中央区東川崎町1-7-5",
  fullAddress: "〒650-0044 兵庫県神戸市中央区東川崎町1-7-5 神戸ハーバーランドumie NORTH MALL 地下1階フードコート",

  // 要確認：プレスリリース原稿は「1-7-2」表記だが、以前の打ち合わせで
  // 「1-7-5」への訂正指示があったため、現時点ではその指示を優先。
  // どちらが正しい住所か、社内でご確認ください。
  addressNote: "住所の号数（1-7-2 か 1-7-5 か）を再確認してください",

  phone: "070-2280-6127",
  phoneDisplay: "070-2280-6127",

  hoursOpen: "11:00",
  hoursClose: "20:00",
  hoursLabel: "11:00〜20:00",
  lastOrder: "19:30",
  lastOrderLabel: "L.O 19:30",

  // 施設（umie）の営業日に準ずる
  regularHoliday: "施設（umie）の営業日に準じます",

  takeout: true,
  takeoutLabel: "テイクアウトOK",

  // 支払方法（確定・2026-09-05）
  paymentMethods: [
    "現金",
    "各種クレジットカード",
    "PayPay",
    "交通系電子マネー",
    "iD",
    "QUICPay",
    "AEON Pay",
  ] as string[] | null,

  // 座席数はユーザー指示によりサイト非掲載（フードコート共用席のため）

  // 要確認：子連れ・ベビーカー対応の詳細が未確定
  kidsStrollerInfo: null as string | null,

  // umie公式サイトに掲載の駐車場情報（確定）
  parkingInfo: "umie立体駐車場・地下駐車場あり",

  // umie公式サイト
  facilityUrl: "https://umie.jp/",

  access: [
    { icon: "train", label: "JR神戸駅から徒歩5分" },
    { icon: "subway", label: "地下鉄海岸線ハーバーランド駅から徒歩5分" },
    { icon: "train", label: "阪神・山陽電鉄 高速神戸駅から徒歩10分" },
  ],

  // 住所から自動生成した検索リンク（実在の住所ベース、実際の店舗ページの登録は別途umie側で必要）
  googleMapsSearchUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("神戸ハーバーランドumie 兵庫県神戸市中央区東川崎町1-7-5"),
  googleMapsEmbedUrl:
    "https://www.google.com/maps?q=%E3%82%A4%E3%82%AA%E3%83%B3%E3%82%B9%E3%82%BF%E3%82%A4%E3%83%ABumie&output=embed",

  // アレルギー情報：Web掲載はせず、店頭案内に統一（確定・2026-09-05）
  allergyInfoUrl: null as string | null,
  allergyNote: "店頭にてお確かめください",

  instagramUrl: "https://www.instagram.com/kobe.minatomachicurry",
  tiktokUrl: "https://www.tiktok.com/@kobe09735",

  recruitUrl: "https://www.baitoru.com/op617952/",

  operatorName: "株式会社なちゅらフーズ",
  operatorSiteUrl: "https://natura-foods.com/",
  // プレスリリース記載の会社概要
  operatorAddress: "大阪府大阪市生野区巽中1-7-1 NTT巽ビル1階",
  operatorDesc: "フードコートを中心に全国22店舗を展開",

  // プレスリリース記載の広報問い合わせ先
  prContactName: "星衛紗輝",
  prPhone: "06-6732-4128",
  prEmail: "office01@natura-foods.com",

  // 公式サイトURL（現在はNetlifyの仮URL。本番ドメイン確定後に要更新）
  siteUrl: "https://graceful-griffin-0ed79a.netlify.app/",
};
